export type GoalsIconCategory = {
    name        : string
    itemIcons   : string[]
}

export const GOALS_ICON_CATEGORIES: GoalsIconCategory[] = [

    {
        name        : 'Popular',
        itemIcons   : [
            'numbers',
            'percent',
            'task',
            'idea',
            'question',
            'bug',

            'beer',
            'book',
            'briefcase',
            'social_broadcast',

            'upload',
            'download',


            'device_mobile',
            'device_desktop',

            'phone',
            'money',

            'device_video',
            'device_camera',
            'database',
            'file_binary',
            'file_code',
            'file_contact',
            'file_text',
            'flame',
            'globe',
            'gift',
            'dev_gist',
            'graph',
            'law',
            'key',
            'link',
            'location',
            'mail',
            'mail_read',
            'mention',
            'milestone',
            'study',
            'pulse',
            'social_rss',
            'search',
            'squirrel',
            'steps',
            'telescope',
            'tools',
            'contact',
            'anchor',
            'bookmark',
            'burst',
            'first_aid',
            'paint_bucket',
            'quote',
            'social_youtube',
            'trophy',
            'shield',
            'shopping_cart',
            'rocket',
            'brush',
            'bucket',
            'social_twitter',
            'userSearch',
            'megaphone',
        ]
    },

    {
        name        : 'Project Management',
        itemIcons   : [
            'folder',
            'project',
            'task',
            'dev',
            'sprint',
            'backlog',
            'requests',
            'group',
            'section',
            'tag',
            'workspace',
            'briefcase',
            'view-projects-list',
            'view-portfolio',
        ]
    },
    {
        name        : 'Views',
        itemIcons   : [
            'view',
            'view-list',
            'view-table',
            'view-board',
            'view-calendar',
            'view-events-summary',
            'event',
            'view-expenses',
            'scrum',
            'view-gantt',
            'view-workload',
            'view-activity',
            'view-what-is-done',
            'view-pastdue',
            'view-priorities',
            'view-action-required',
            'view-tasks-by-user',
            'view-dashboard',
            'report',
            'user',
            'users'
        ]
    },
    {
        name        : 'Development & Technology',
        itemIcons   : [
            'project-dev',
            'mobile',
            'desktop',
            'globe',
            'cloud',
            'upload',
            'cloud-download',
            'server',
            'database',
            'key',
            'api',
            'qa',
            'bug',
            'idea',
            'rocket',
            'microchip',
            'embed',
            'lightning',
            'network',
            'graph',
            'cloud-upload',
            'pulse',
            'shield',
        ]
    },
    {
        name        : 'Collaboration & Communication',
        itemIcons   : [
            'phone',
            'support',
            'megaphone',
            'contact',
            'leads',
            'mail-black',
            'mail-read',
            'user-search',
            'social_broadcast',
            'target',
            'aim',
            'mention',
            'quote',
            'rss',
            'search',
            'resources',
            'request',
            'request2',
            'copy-link',
            'user-card', 'offices',
            'broadcast',
            'question',
        ]
    },
    {
        name        : 'Documentation',
        itemIcons   : [
            'files',
            'page',
            'file_audio',
            'file_media',
            'file_video',
            'file_archive',
            'file-binary',
            'file-code',
            'file-contact',
            'file-text',
            'spreadsheet',
            'img',
        ]
    },
    {
        name        : 'Financials & e-commerce',
        itemIcons   : [
            'money',
            'credit_card',
            'inventory',
            'shopping-cart',
            'suitcase',
            'numbers',
            'percent',
        ]
    },
    {
        name        : 'Education',
        itemIcons   : [
            'bookmark',
            'book',
            'wiki',
            'graduate',
            'graduation'
        ]
    },
    {
        name        : 'Creativity & Design',
        itemIcons   : [
            'pencil',
            'paint-bucket',
            'paint_roller',
            'brush',
        ]
    },
    {
        name        : 'Brands',
        itemIcons   : [
            'windows',
            'android',
            'apple',
            'figma',
            'googleCalendar',
            'googleDoc',
            'googleMap',
            'googleSheet',
            'googleSlides',
            'twitterX',
            'social-twitter',
            'facebook',
            'youtube',
            'social-youtube',
            'brand',
        ]
    },
    {
        name        : 'Entertainment & Media',
        itemIcons   : [
            'device-mobile',
            'device-desktop',
            'device-camera-video',
            'chess',
            'game_console',
            'music',
            'speaker',
            'microphone',
            'football_ball',
            'flask',
            'beer',
            'birthday_cake',
            'hotel',
            'first_aid',
            'flame',
            'tshirt',
            'wheelchair',
            'flag',
            'squirrel',
            'tools',
            'telescope',
            'home',
            'milestone',
            'geo',
            'watch',
            'law',
            'feather',
            'magic_wand',
            'projection_screen',
            'smile',
            'smile_sad',
            'zzz',
            'burst',
            'life_ring',
            'tachometer',
            'anchor',
            'trophy',
            'gift',
            'location',
            'steps',
            'first-aid',
        ]
    },

]
